import React from 'react';
import { Button } from '@mui/material';
import './contactus.css';

function Contactus({ onOpenContact }) {
  return (
    <div className='contactus'>
      <div className='contacttext'>
        <span className='eyebrow light'>Let’s build your next success story</span>
        <h2>Get started now</h2>
        <p>We’re one conversation away from turning your next idea into a scalable digital solution.</p>
      </div>

      <div className='buttonn'>
        <Button variant='contained' className='contactButton' onClick={() => onOpenContact('contact')}>
          Contact Us
        </Button>
      </div>
    </div>
  );
}

export default Contactus;